import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "role-card-capabilities-skills"
};
const _hoisted_2 = {
  class: "group-container"
};
const _hoisted_3 = {
  class: "group-title"
};
const _hoisted_4 = {
  key: 0,
  class: "data-container"
};
const _hoisted_5 = {
  style: {
    "width": "100%",
    "flex": "1"
  }
};
const _hoisted_6 = {
  key: 1,
  class: "data-container"
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "gap": "16px",
    "width": "100%"
  }
};
const _hoisted_8 = {
  class: "group-container"
};
const _hoisted_9 = {
  class: "group-title"
};
const _hoisted_10 = {
  key: 0,
  class: "data-container"
};
const _hoisted_11 = {
  style: {
    "width": "100%",
    "flex": "1"
  }
};
const _hoisted_12 = {
  key: 1,
  class: "data-container"
};
const _hoisted_13 = {
  style: {
    "width": "100%",
    "flex": "1"
  }
};
const _hoisted_14 = {
  class: "group-container"
};
const _hoisted_15 = {
  class: "grid-container"
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  key: 0,
  class: "acquired-tag"
};
const _hoisted_19 = {
  class: "explain"
};
const _hoisted_20 = {
  class: "group-container"
};
import { ref, computed, onMounted, watch } from 'vue';
import { ElRow, ElButton, ElSelect, ElOption, ElMessage } from 'element-plus';
import { List, Reading } from "@element-plus/icons-vue";
import { getCapabilitiesWithTypeId, getCapability, getProperty, isUserType } from '@/tools/utils';
import { request } from '@/manager/net_manager';
import store from '@/store';
import RoleCapabilityCard from '@/components/Capability/RoleCapabilityCard.vue';
import RoleSkillTree from '@/components/Skills/RoleSkillTree.vue';
import RoleCapabilityEditCard from '@/components/Capability/RoleCapabilityEditCard.vue';
import RoleSkillEditCard from '@/components/Skills/RoleSkillEditCard.vue';
import RoleSkillCard from '@/components/Skills/RoleSkillCard.vue';
import RoleDataCollapse from "@/components/Role/RoleDataCollapse.vue";
import MaskerLayer from '@/components/Basic/MaskerLayer.vue'; // constants

export default {
  __name: 'RoleCardCapabilitiesSkills',
  props: {
    roleId: {
      type: [String, Number],
      required: true
    }
  },
  emits: ['toTop'],

  setup(__props, {
    emit: __emit
  }) {
    const degreeOptions = ['SS', 'S', 'A', 'B', 'C']; // pre-declaration

    const props = __props;
    const emits = __emit; // refs

    const message = ref(null);
    const contentContainer = ref(null);
    const capabilityGroupMode = ref(true);
    const skillGroupMode = ref(true);
    const addCapabilityMode = ref(false);
    const addCapabilityType = ref(null);
    const skillTreeMode = ref(false); // 技能流派筛选

    const organization = ref(null);
    const editCapability = ref(null);
    const editSkill = ref(null); // computed

    const capabilityConfigure = computed(() => store.state.capability_configure);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const attribute = computed(() => store.state.role_info[props.roleId]?.attribute ?? null);
    const roleOrganizations = computed(() => attribute.value?.organizations ?? []);
    const roleProperties = computed(() => attribute.value?.properties ?? {});
    const roleCapabilities = computed(() => {
      if (!attribute.value) return null;
      if (!attribute.value?.capabilities) return null;
      return (attribute.value?.capabilities ?? []).map(item => {
        let highlight = 0;
        if (item['skilled']) highlight++;
        if (item['limiter_degree'] !== 0) highlight += item['limiter_degree'];
        const buffer = {
          'title': getCapabilityTitle(item),
          'subtitle': getCapabilitySubTitle(item),
          'highlight': highlight
        };
        return { ...item,
          ...buffer
        };
      });
    });
    const roleSkills = computed(() => {
      if (!attribute.value) return null;
      if (!attribute.value?.skills) return null;
      return (attribute.value?.skills ?? []).map(item => {
        let highlight = 0;
        if (item['skilled_path'] || item['mutates_type']) highlight++;
        if (item['over_limit_path']) highlight += 2;
        const buffer = {
          'title': getSkillTitle(item),
          'subtitle': getSkillSubTitle(item),
          'highlight': highlight
        };
        return { ...item,
          ...buffer
        };
      });
    });
    const roleCapabilitiesGroupData = computed(() => {
      if (!roleCapabilities.value) return {};
      const buffer = {};
      roleCapabilities.value.forEach(item => {
        if (!buffer[item.capability_type_id]) buffer[item.capability_type_id] = [];
        buffer[item.capability_type_id].push(item);
      });
      return Object.entries(buffer).filter(([, items]) => items.length > 0).reduce((acc, [type, items]) => ({ ...acc,
        [type]: items
      }), {});
    });
    const roleSkillsGroupData = computed(() => {
      if (!roleSkills.value) return {};
      const buffer = {};
      degreeOptions.forEach(degree => {
        buffer[degree] = [];
      });
      roleSkills.value.forEach(item => {
        if (!buffer[item.degree]) buffer[item.degree] = [];
        buffer[item.degree].push(item);
      });
      return Object.entries(buffer).filter(([, items]) => items.length > 0).reduce((acc, [degree, items]) => ({ ...acc,
        [degree]: items
      }), {});
    });
    const capabilityPoint = computed(() => store.state.role_info[props.roleId]?.capability_point ?? 0);
    const skillsPoint = computed(() => store.state.role_info[props.roleId]?.skill_point ?? 0);
    const capabilitiesIds = computed(() => {
      if (!roleCapabilities.value) return [];
      let buffer = [];

      if (addCapabilityType.value) {
        buffer = roleCapabilities.value.filter(item => item?.capability_type_id.toString() === addCapabilityType.value.toString());
      } else {
        buffer = roleCapabilities.value;
      }

      return buffer.map(item => item.capability_id.toString());
    });
    const capabilities = computed(() => {
      if (!capabilityConfigure.value) return [];
      let buffer = [];

      if (addCapabilityType.value) {
        buffer = Object.values(getCapabilitiesWithTypeId(addCapabilityType.value));
      } else {
        buffer = Object.values(Object.assign({}, ...Object.values(capabilityConfigure.value).map(item => item?.children ?? {})));
      }

      return buffer.filter(item => !item['extraordinary']).map(item => {
        const capabilityId = item?.capability_id ?? -1;
        return { ...item,
          ...{
            'acquired': capabilitiesIds.value.includes(capabilityId.toString())
          }
        };
      });
    }); // 角色能力信息表

    const capabilityBaseInfo = computed(() => {
      if (!roleCapabilities.value) return [];
      const result = {};

      for (const item of roleCapabilities.value) {
        const key = item.capability_id.toString();
        result[key] = getCapability(key, {
          properties: roleProperties.value
        });
      }

      return result;
    }); // functions

    const getData = () => {
      getCapabilityData();
      getSkillData();
    };

    const getCapabilityData = (force = false) => {
      if (!roleCapabilities.value || force) {
        request('capabilities/role_capabilities/list/', {
          'role_id': props.roleId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            const buffer = structuredClone(attribute.value);
            buffer.capabilities = response.data;
            store.commit('update_role_info', {
              role_id: props.roleId,
              key: 'attribute',
              value: buffer
            });
          }
        });
      }
    };

    const getSkillData = (force = false) => {
      if (!roleSkills.value || force) {
        request('skills/role_skills/list/', {
          'role_id': props.roleId
        }, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            const buffer = structuredClone(attribute.value);
            buffer.skills = response.data;
            store.commit('update_role_info', {
              role_id: props.roleId,
              key: 'attribute',
              value: buffer
            });
          }
        });
      }
    };

    const getCapabilityTitle = item => {
      if (!item) return '';
      let capabilityTitle = item['capability_name'];

      if (item['limiter_degree'] > 0) {
        capabilityTitle += '【超限】';
      } else if (item['skilled']) {
        capabilityTitle += '【专精】';
      }

      capabilityTitle += `：\u3000${item['probability']}`;
      let detail = [];

      if (item['base_value'] + item['nature_value'] !== 0) {
        detail.push(`天性${item['base_value'] + item['nature_value']}`);
      }

      if (item['value'] !== 0) {
        detail.push(`分配${item['value']}`);
      }

      if (item['grew_value'] !== 0) {
        detail.push(`成长${item['grew_value']}`);
      }

      if (detail.length === 0) {
        return capabilityTitle;
      } else {
        return `${capabilityTitle}\u3000（${detail.join(' / ')}）`;
      }
    };

    const getCapabilitySubTitle = item => {
      if (!item) return '';
      if (!isUserType(userType.value)) return '';
      if (item['extraordinary']) return '';
      if (capabilityPoint.value <= 0) return '';
      return item['max_value'] > item['probability'] ? '可分配' : '';
    };

    const getCapabilityTypeName = typeId => {
      if (!typeId) return '';
      const typeData = capabilityConfigure.value[typeId.toString()];
      if (!typeData) return '';
      return typeData?.desc ?? '';
    };

    const getCapabilityBaseValueDesc = baseValue => {
      if (typeof baseValue === 'number' || !baseValue.includes(',')) {
        return baseValue;
      }

      const parts = baseValue.split(',').map(part => part.trim());

      if (parts.length === 2 && !isNaN(parts[0])) {
        let numericPart = parseFloat(parts[0]);
        let variablePart = getProperty(parts[1]);
        return `${numericPart} * ${variablePart}`;
      }
    };

    const openCapabilityEditor = item => {
      editCapability.value = item;
    };

    const openCapabilityMode = (typeId = null) => {
      addCapabilityType.value = typeId;
      addCapabilityMode.value = true;
    };

    const addCapability = capability => {
      if (capability.acquired) {
        // message.value = ElMessage.warning({message: '已经拥有该能力', duration: 1500})
        return;
      }

      if (message.value) {
        message.value.close();
      }

      request('capabilities/role_capabilities/create/', {
        'role_id': props.roleId,
        'capability_id': capability.capability_id
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code !== 0) {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          return;
        }

        getCapabilityData(true);
        message.value = ElMessage.success({
          message: '能力新增完成',
          duration: 1500
        });
      });
    };

    const getSkillTitle = item => {
      if (!item) return '';
      let skillTitle = item['name'];

      if (item['over_limit_path']) {
        skillTitle += '【超限】';
      } else if (item['skilled_path']) {
        skillTitle += '【专精】';
      }

      if (item['mutates_type']) {
        skillTitle += `【${item['mutates_type']}】`;
      }

      skillTitle += `：\u3000${item['probability']}`;
      let difference = item['probability'] - item['probability_base'];

      if (difference !== 0) {
        skillTitle = `${skillTitle}\u3000（${item['probability_base']} ${difference < 0 ? '-' : '+'} ${Math.abs(difference)}）`;
      }

      return skillTitle;
    };

    const getSkillSubTitle = item => {
      if (!item) return '';
      if (!isUserType(userType.value)) return '';
      if (item['probability_grow'] === 0) return '';
      if (skillsPoint.value <= 0) return '';
      return item['max_value'] > item['probability'] ? '可精进' : '';
    };

    const openRoleSkillEditor = item => {
      editSkill.value = item;
    };

    const openSkillTreeMode = () => {
      if (roleOrganizations.value.length === 0) {
        ElMessage.error({
          message: '没有加入任何世界观组织',
          duration: 1500
        });
        return;
      }

      organization.value = roleOrganizations.value[0].id;
      skillTreeMode.value = true;
      setTimeout(() => {
        emits('toTop');
      }, 200);
    }; // lifecycle


    onMounted(() => {
      getData();
    }); // watcher

    watch(() => props.roleId, () => {
      getData();
      addCapabilityType.value = null;
      addCapabilityMode.value = false;
      skillTreeMode.value = false;
    });
    watch(() => roleSkills.value, () => getSkillData());
    watch(() => roleCapabilities.value, () => getCapabilityData());
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_switch = _resolveComponent("el-switch");

      return __props.roleId ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(["content-container", [addCapabilityMode.value ? 'capability-mode' : '', skillTreeMode.value ? 'skill-tree-mode' : '']]),
        ref_key: "contentContainer",
        ref: contentContainer
      }, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(List))]),
            _: 1
          }), _createElementVNode("text", _hoisted_3, "能力列表（" + _toDisplayString(capabilityGroupMode.value ? '组别' : '一览') + "）", 1)]),
          _: 1
        }), _createVNode(_component_el_switch, {
          modelValue: capabilityGroupMode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => capabilityGroupMode.value = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), !capabilityGroupMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(RoleDataCollapse, {
        "data-array": roleCapabilities.value
      }, {
        default: _withCtx(({
          item
        }) => [_createVNode(RoleCapabilityCard, {
          "role-id": __props.roleId,
          data: item,
          onUpdate: _cache[1] || (_cache[1] = $event => getCapabilityData(true)),
          onEdit: openCapabilityEditor
        }, null, 8, ["role-id", "data"])]),
        _: 1
      }, 8, ["data-array"])]), _unref(isUserType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 0,
        class: "add-item",
        onClick: _cache[2] || (_cache[2] = $event => openCapabilityMode(null))
      }, {
        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" 添加新的能力项 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleCapabilitiesGroupData.value, (typeCapabilities, typeId) => {
        return _openBlock(), _createElementBlock("div", {
          key: `type-capabilities-${typeId}`
        }, [_createVNode(RoleDataCollapse, {
          "data-array": typeCapabilities,
          "data-title": getCapabilityTypeName(typeId)
        }, {
          default: _withCtx(({
            item
          }) => [_createVNode(RoleCapabilityCard, {
            "role-id": __props.roleId,
            data: item,
            onUpdate: _cache[3] || (_cache[3] = $event => getCapabilityData(true)),
            onEdit: openCapabilityEditor
          }, null, 8, ["role-id", "data"])]),
          _: 1
        }, 8, ["data-array", "data-title"]), _unref(isUserType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          class: "add-item-group",
          onClick: $event => openCapabilityMode(typeId)
        }, {
          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode(" 添加新的能力项 ", -1)]))]),
          _: 1
        }, 8, ["onClick"])) : _createCommentVNode("", true)]);
      }), 128))]), roleCapabilities.value && roleCapabilities.value.length === 0 && _unref(isUserType)(userType.value) ? (_openBlock(), _createBlock(_unref(ElButton), {
        key: 0,
        class: "add-item-group",
        onClick: _cache[4] || (_cache[4] = $event => openCapabilityMode(null))
      }, {
        default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode(" 添加新的能力项 ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true)]))]), _createElementVNode("div", _hoisted_8, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "center",
          "justify-content": "space-between"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          style: {
            "align-items": "center"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: 18
          }, {
            default: _withCtx(() => [_createVNode(_unref(Reading))]),
            _: 1
          }), _createElementVNode("text", _hoisted_9, "技能列表（" + _toDisplayString(skillGroupMode.value ? '组别' : '一览') + "）", 1)]),
          _: 1
        }), _createVNode(_component_el_switch, {
          modelValue: skillGroupMode.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => skillGroupMode.value = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }), !skillGroupMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(RoleDataCollapse, {
        "data-array": roleSkills.value
      }, {
        default: _withCtx(({
          item
        }) => [_createVNode(RoleSkillCard, {
          "role-id": __props.roleId,
          data: item,
          onUpdate: _cache[6] || (_cache[6] = $event => getSkillData(true)),
          onEdit: openRoleSkillEditor
        }, null, 8, ["role-id", "data"])]),
        _: 1
      }, 8, ["data-array"])]), _createVNode(_unref(ElButton), {
        class: "add-item",
        onClick: openSkillTreeMode
      }, {
        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createTextVNode(" 打开技能树 ", -1)]))]),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleSkillsGroupData.value, (typeSkills, degree) => {
        return _openBlock(), _createElementBlock("div", {
          key: `type-skills-${degree}`,
          style: {
            "width": "100%"
          }
        }, [_createVNode(RoleDataCollapse, {
          "data-array": typeSkills,
          "data-title": `${degree}级`
        }, {
          default: _withCtx(({
            item
          }) => [_createVNode(RoleSkillCard, {
            "role-id": __props.roleId,
            data: item,
            onUpdate: _cache[7] || (_cache[7] = $event => getSkillData(true)),
            onEdit: openRoleSkillEditor
          }, null, 8, ["role-id", "data"])]),
          _: 1
        }, 8, ["data-array", "data-title"])]);
      }), 128))]), _createVNode(_unref(ElButton), {
        class: "add-item-group",
        onClick: openSkillTreeMode
      }, {
        default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode(" 打开技能树 ", -1)]))]),
        _: 1
      })]))])], 2), _createElementVNode("div", {
        class: _normalizeClass(["capability-container", addCapabilityMode.value ? 'capability-mode' : ''])
      }, [_createElementVNode("div", _hoisted_14, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "margin-bottom": "16px",
          "align-items": "center",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElButton), {
          class: "exit-mode",
          onClick: _cache[8] || (_cache[8] = $event => addCapabilityMode.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(" 离开列表 " + _toDisplayString(addCapabilityType.value ? `（${getCapabilityTypeName(addCapabilityType.value)}）` : ''), 1)]),
          _: 1
        })]),
        _: 1
      }), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addCapabilityMode.value ? capabilities.value : [], (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["capability-card", item.acquired ? 'acquired' : '']),
          onClick: $event => addCapability(item)
        }, [_createElementVNode("text", _hoisted_17, [_createTextVNode(_toDisplayString(item.desc) + " ", 1), item.acquired ? (_openBlock(), _createElementBlock("span", _hoisted_18, "   <已掌握> ")) : _createCommentVNode("", true)]), _cache[22] || (_cache[22] = _createElementVNode("div", {
          class: "divider"
        }, null, -1)), _createVNode(_unref(ElRow), {
          class: "type-desc"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(getCapabilityTypeName(item?.type?.capability_type_id)), 1), _createElementVNode("text", null, " 基础值：" + _toDisplayString(getCapabilityBaseValueDesc(item?.base_value)), 1)]),
          _: 2
        }, 1024), _createElementVNode("text", _hoisted_19, _toDisplayString(item.explain), 1)], 10, _hoisted_16);
      }), 128))])])], 2), _createElementVNode("div", {
        class: _normalizeClass(["skill-tree-container", skillTreeMode.value ? 'skill-tree-mode' : ''])
      }, [_createElementVNode("div", _hoisted_20, [_createVNode(_unref(ElRow), {
        style: {
          "width": "100%",
          "margin-bottom": "16px",
          "align-items": "center",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [organization.value && roleOrganizations.value.length > 1 ? (_openBlock(), _createBlock(_unref(ElSelect), {
          key: 0,
          modelValue: organization.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => organization.value = $event),
          placeholder: "选择流派",
          class: _normalizeClass(organization.value ? 'selected-selector' : ''),
          "popper-class": "commonPopper"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleOrganizations.value, (item, index) => {
            return _openBlock(), _createBlock(_unref(ElOption), {
              key: index,
              label: item['name'],
              value: item['id']
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue", "class"])) : _createCommentVNode("", true), _cache[24] || (_cache[24] = _createElementVNode("div", {
          style: {
            "flex": "1"
          }
        }, null, -1)), _createVNode(_unref(ElButton), {
          class: "exit-mode",
          onClick: _cache[10] || (_cache[10] = $event => skillTreeMode.value = false)
        }, {
          default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode(" 离开技能树 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }), __props.roleId && organization.value ? (_openBlock(), _createBlock(RoleSkillTree, {
        key: 0,
        "role-id": __props.roleId,
        "organization-id": organization.value
      }, null, 8, ["role-id", "organization-id"])) : _createCommentVNode("", true)])], 2), editCapability.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[13] || (_cache[13] = $event => editCapability.value = null)
      }, {
        default: _withCtx(() => [_createVNode(RoleCapabilityEditCard, {
          capability: editCapability.value,
          "capability-base-info": capabilityBaseInfo.value[editCapability.value['capability_id']],
          onClose: _cache[11] || (_cache[11] = $event => editCapability.value = null),
          onComplete: _cache[12] || (_cache[12] = $event => getCapabilityData(true))
        }, null, 8, ["capability", "capability-base-info"])]),
        _: 1
      })) : _createCommentVNode("", true), editSkill.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 1,
        onClose: _cache[16] || (_cache[16] = $event => editSkill.value = null)
      }, {
        default: _withCtx(() => [_createVNode(RoleSkillEditCard, {
          skill: editSkill.value,
          onClose: _cache[14] || (_cache[14] = $event => editSkill.value = null),
          onComplete: _cache[15] || (_cache[15] = $event => getSkillData(true))
        }, null, 8, ["skill"])]),
        _: 1
      })) : _createCommentVNode("", true)])) : _createCommentVNode("", true);
    };
  }

};